import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import '@fontsource-variable/inter';
import { store } from '@/store/store';
import { router } from '@/routes';
import { getStoredTheme } from '@/hooks/useTheme';
import { registerNativeDeepLinks } from '@/lib/native/deep-links';
import './index.css';

const initialTheme = getStoredTheme() ?? 'dark';
document.documentElement.classList.toggle('dark', initialTheme === 'dark');
registerNativeDeepLinks((path) => void router.navigate(path));

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </StrictMode>,
);
